export default {
  name: 'datetime',
  type: 'action',
  isRequired: false,
  essential: true
}
